import { cn } from "@/lib/utils/global-utils";
import React, { forwardRef } from "react";

interface LogoProps extends React.SVGProps<SVGSVGElement> {}

const LewkLogo = forwardRef<SVGSVGElement, LogoProps>(
  ({ className, ...rest }, ref) => (
    <svg
      ref={ref}
      className={cn("", className)}
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
      width="104.689"
      height="24"
      viewBox="0 0 104.689 24"
    >
      <g id="lewk-logo" transform="translate(-0.105 -21.811)">
        <g id="Grupo_3" data-name="Grupo 3" transform="translate(0.105 21.811)">
          <g id="Grupo_2" data-name="Grupo 2" transform="translate(0 0)">
            <g id="Grupo_1" data-name="Grupo 1">
              <path
                id="Trazado_1"
                data-name="Trazado 1"
                d="M19.258-102.194a.576.576,0,0,1,.635-.282.438.438,0,0,1,.356.467q0,.143-.19,1.159t-.375,2.144q-.19,1.133-.282,1.792a1.675,1.675,0,0,1-.333,1.016,1.24,1.24,0,0,1-.944.305H.551a.416.416,0,0,1-.426-.355.6.6,0,0,1,.236-.637A4.7,4.7,0,0,0,1.944-98.4a5.835,5.835,0,0,0,.356-2.19v-14.051a6.081,6.081,0,0,0-.356-2.194,4.319,4.319,0,0,0-1.583-1.815.569.569,0,0,1-.236-.61.41.41,0,0,1,.426-.332h9.826q.755,0,.8.425a.732.732,0,0,1-.329.707,3.467,3.467,0,0,0-1.041,1.792,17.4,17.4,0,0,0-.565,2.9q-.19,1.626-.259,3.275t-.07,2.877q0,1.179.046,2.758T9.2-101.7a20.076,20.076,0,0,0,.542,2.877,4.616,4.616,0,0,0,.921,1.908h1.56a4.861,4.861,0,0,0,2.837-.966,13.966,13.966,0,0,0,2.477-2.24Q18.642-101.395,19.258-102.194Zm0,0"
                transform="translate(-0.105 119.594)"
              />
            </g>
          </g>
        </g>
        <g
          id="Grupo_6"
          data-name="Grupo 6"
          transform="translate(20.652 21.811)"
        >
          <g id="Grupo_5" data-name="Grupo 5" transform="translate(0 0)">
            <g id="Grupo_4" data-name="Grupo 4" transform="translate(0)">
              <path
                id="Trazado_2"
                data-name="Trazado 2"
                d="M18.5-101.206a.577.577,0,0,1,.635-.282.44.44,0,0,1,.356.471v4.1a1.169,1.169,0,0,1-1.323,1.321H.551a.416.416,0,0,1-.426-.355.6.6,0,0,1,.236-.637A4.7,4.7,0,0,0,1.944-98.4a5.835,5.835,0,0,0,.356-2.19v-14.051a6.081,6.081,0,0,0-.356-2.194,4.319,4.319,0,0,0-1.583-1.815.569.569,0,0,1-.236-.61.41.41,0,0,1,.426-.332H13.824a11.124,11.124,0,0,1,2.481.286,5.24,5.24,0,0,1,2.1.942,2.191,2.191,0,0,1,.851,1.838,2.654,2.654,0,0,1-.708,2,2.707,2.707,0,0,1-1.749.757,3.774,3.774,0,0,1-2.078-.494,4.42,4.42,0,0,1-1.7-1.7,4.489,4.489,0,0,0-1.633-1.885,4.81,4.81,0,0,0-1.912-.425q-.139,1.321-.329,3.916t-.236,6.079h.944a5.056,5.056,0,0,0,2.078-.305,2.037,2.037,0,0,0,.921-.9,9.591,9.591,0,0,1,.921-1.39.625.625,0,0,1,.635-.309q.356.069.356.545v6.033q0,.472-.356.545a.639.639,0,0,1-.635-.263,11.622,11.622,0,0,1-.921-1.437,2.018,2.018,0,0,0-.921-.9,5.073,5.073,0,0,0-2.078-.305H8.914q.046,2.264.163,4.785t.449,5.257H13.07a4.023,4.023,0,0,0,2.453-.73A7.1,7.1,0,0,0,17.2-99.39Q17.888-100.406,18.5-101.206Zm0,0"
                transform="translate(-0.105 119.594)"
              />
            </g>
          </g>
        </g>
        <g
          id="Grupo_9"
          data-name="Grupo 9"
          transform="translate(40.484 21.811)"
        >
          <g id="Grupo_8" data-name="Grupo 8" transform="translate(0 0)">
            <g id="Grupo_7" data-name="Grupo 7" transform="translate(0)">
              <path
                id="Trazado_3"
                data-name="Trazado 3"
                d="M38.641-119.594a.474.474,0,0,1,.5.332q.119.329-.352.61-1.042.614-1.583.923a2.954,2.954,0,0,0-.851.684,4.705,4.705,0,0,0-.639,1.271L28.2-97.1a2.17,2.17,0,0,1-1.041,1.3,1.717,1.717,0,0,1-1.467.046A2.416,2.416,0,0,1,24.47-97.1q-.566-1.321-1.44-3.441t-1.819-4.5q-.945-2.383-1.8-4.457L14.408-97.1a2.154,2.154,0,0,1-1.041,1.3,1.708,1.708,0,0,1-1.463.046A2.416,2.416,0,0,1,10.678-97.1q-.569-1.321-1.467-3.488t-1.865-4.55q-.968-2.383-1.819-4.527t-1.393-3.538q-.543-1.39-.542-1.437a17.248,17.248,0,0,0-1.064-2.194A5.609,5.609,0,0,0,.38-118.651q-.473-.281-.356-.61a.447.447,0,0,1,.449-.332H11.15a.37.37,0,0,1,.426.332.756.756,0,0,1-.19.61,2.5,2.5,0,0,0-.875,1.815,6.989,6.989,0,0,0,.5,2.194q0,.046.472,1.275t1.2,3.04q.734,1.816,1.49,3.75t1.37,3.437l3.166-8.061-1.37-3.441a12.342,12.342,0,0,0-1.041-2.194,5.838,5.838,0,0,0-2.171-1.815q-.473-.281-.333-.61a.489.489,0,0,1,.476-.332H24.9a.593.593,0,0,1,.426.189.508.508,0,0,1,0,.425.509.509,0,0,1-.19.328,2.656,2.656,0,0,0-.851,1.815,5.959,5.959,0,0,0,.522,2.194q0,.046.472,1.275t1.2,3.04q.731,1.816,1.486,3.75t1.323,3.437L34.3-115.774a4.346,4.346,0,0,0,.333-1.271.977.977,0,0,0-.286-.684l-.847-.923a.641.641,0,0,1-.213-.61.374.374,0,0,1,.4-.332Zm0,0"
                transform="translate(-0.001 119.594)"
              />
            </g>
          </g>
        </g>
        <g
          id="Grupo_12"
          data-name="Grupo 12"
          transform="translate(75.246 21.811)"
        >
          <g id="Grupo_11" data-name="Grupo 11" transform="translate(0 0)">
            <g id="Grupo_10" data-name="Grupo 10" transform="translate(0)">
              <path
                id="Trazado_4"
                data-name="Trazado 4"
                d="M23.84-96.776a.7.7,0,0,1,.4.734q-.07.449-.875.448H12.927a.351.351,0,0,1-.4-.355.872.872,0,0,1,.213-.637,2.885,2.885,0,0,0,.995-1.815,6.9,6.9,0,0,0-.333-2.19q-.237-.946-.639-2.074a13.606,13.606,0,0,0-.967-2.144,6.367,6.367,0,0,0-1.273-1.653,1.864,1.864,0,0,0-1.606-.494q0,1.272.093,2.827t.282,3.067A14.18,14.18,0,0,0,9.858-98.4a3.284,3.284,0,0,0,.991,1.626.765.765,0,0,1,.329.734q-.046.449-.8.448H.551a.416.416,0,0,1-.426-.355.6.6,0,0,1,.236-.637A4.7,4.7,0,0,0,1.944-98.4a5.835,5.835,0,0,0,.356-2.19v-14.051a6.081,6.081,0,0,0-.356-2.194,4.319,4.319,0,0,0-1.583-1.815.569.569,0,0,1-.236-.61.41.41,0,0,1,.426-.332h9.826q.755,0,.8.425a.732.732,0,0,1-.329.707,4,4,0,0,0-1.2,2.313,23.192,23.192,0,0,0-.546,3.77q-.139,2.074-.186,3.77a7.041,7.041,0,0,0,1.393-1.835q.731-1.275,1.629-2.831a23.359,23.359,0,0,1,2.055-2.993,11.21,11.21,0,0,1,2.6-2.383,5.878,5.878,0,0,1,3.285-.942,2.228,2.228,0,0,1,1.981.9,3.422,3.422,0,0,1,.569,2.124,4.592,4.592,0,0,1-.639,2.217,2.389,2.389,0,0,1-1.583,1.2,2.809,2.809,0,0,1-2.314-.969,1.834,1.834,0,0,0-1.865-.541,4.4,4.4,0,0,0-1.819,1.3,22.413,22.413,0,0,0-1.772,2.24q-.875,1.248-1.722,2.333a5.139,5.139,0,0,1,3.444.471,7.792,7.792,0,0,1,2.481,2.263,33.712,33.712,0,0,1,2.055,3.206,31.715,31.715,0,0,0,2.221,3.372A11.153,11.153,0,0,0,23.84-96.776Zm0,0"
                transform="translate(-0.105 119.594)"
              />
            </g>
          </g>
        </g>
        <g
          id="Grupo_15"
          data-name="Grupo 15"
          transform="translate(99.786 40.804)"
        >
          <g id="Grupo_14" data-name="Grupo 14" transform="translate(0 0)">
            <g id="Grupo_13" data-name="Grupo 13">
              <path
                id="Trazado_5"
                data-name="Trazado 5"
                d="M2.5-42.719a2.455,2.455,0,0,1,1.772.708,2.393,2.393,0,0,1,.731,1.8,2.42,2.42,0,0,1-.731,1.772,2.414,2.414,0,0,1-1.772.731,2.413,2.413,0,0,1-1.772-.731A2.42,2.42,0,0,1,0-40.215a2.393,2.393,0,0,1,.731-1.8A2.453,2.453,0,0,1,2.5-42.719Zm0,0"
                transform="translate(0 42.719)"
                fill="#b1a1ed"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
);

LewkLogo.displayName = "Lewk Logo";

export { LewkLogo };
